import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import MobileStepper from "@material-ui/core/MobileStepper";
import Button from "@material-ui/core/Button";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
    paddingLeft: 0,
    paddingRight: 0,
    "& .MuiLinearProgress-root": {
      width: "calc(100% - 120px)",
      margin: "0 8px",
      maxWidth: 800,
    },
  },
  btn: {
    textTransform: "none",
  },
}));

export const AssessmentStepper = ({
  activeStep,
  steps,
  handleNext,
  handleBack,
  handleComplete,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const progressLineSteps = steps + 1;

  const request = useSelector((state) => state.request.request);

  const isButtonDisabled = () => request.isFetching;
  const isCompletedButtonDisabled = () =>
    isButtonDisabled() || request.type === "sucesss";

  return (
    <>
      <MobileStepper
        variant="progress"
        steps={progressLineSteps}
        position="static"
        activeStep={activeStep}
        className={classes.root}
        nextButton={
          activeStep < steps ? (
            <Button
              disabled={isButtonDisabled()}
              className={classes.btn}
              size="small"
              name="nextBtn"
              data-testid="nextBtn"
              onClick={handleNext}
            >
              Next
              {theme.direction === "rtl" ? (
                <KeyboardArrowLeft />
              ) : (
                <KeyboardArrowRight />
              )}
            </Button>
          ) : (
            <Button
              className={classes.btn}
              size="small"
              variant="contained"
              color="primary"
              name="completeBtn"
              data-testid="completeBtn"
              onClick={handleComplete}
              disabled={isCompletedButtonDisabled()}
            >
              Go to Account
            </Button>
          )
        }
        backButton={
          <Button
            size="small"
            className={classes.btn}
            onClick={handleBack}
            disabled={activeStep <= 0 || isButtonDisabled()}
          >
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
      <span>
        {Math.min(activeStep + 1, steps)} / {steps}
      </span>
    </>
  );
};

AssessmentStepper.propTypes = {
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.number.isRequired,
  handleNext: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleComplete: PropTypes.func.isRequired,
};
